import { Directive, OnInit, TemplateRef } from '@angular/core';

import { ModalDialogComponent } from './modal-dialog.component';
import { Dialog } from '../../providers/modal/modal-types';

/**
 * A helper directive used to correctly embed the modal title in the {@link ModalDialogComponent}.
 */
@Directive({ selector: '[vsfDialogTitle]' })
export class DialogTitleDirective implements OnInit {
    constructor(private modal: ModalDialogComponent<void, Dialog<void>>, private templateRef: TemplateRef<void>) {}

    ngOnInit() {
        this.modal.registerTitleTemplate(this.templateRef);
    }
}
